import { TabName } from './_enum-collections';

export class EngagementSearchAndFilterInput {
  searchString!: string;
  engagementKey!: number;
  taskOwners!: string[];
  taskOwner!: string | null;
  incentiveStatus!: string | null;
  incentiveStatuses!: string[];
  l1InternalStatus!: string | null;
  l1InternalStatuses!: string[];
  poeStatus!: string | null;
  poeStatuses!: string[];
  originalProgram!: string;
  mCAPEngagementID!: string;
  requestID!: string;
  requestDate?: Date;
  engagementSubType!: string;
  status!: string;
  partnerInputParnterName!: string;
  partnerOneID?: number;
  partnerInputMPNId?: number;
  partnerInputCustomerTPId?: number;
  partnerInputCustomerTenantId!: string;
  partnerInputCustomerDomainName!: string;
  inputPayeeEmail!: string;
  inputRequestorEmail!: string;
  inputProfileStatus!: string | null;
  inputProfileStatuses!: string[];
  inputProgramType!: string | null;
  inputProgramTypes!: string[];
  programTypeId?: number;
  tabName!: TabName;
  sortField!: string;
  sortOrderDescending!: boolean;
  page!: number;
  pageSize!: number;

  computeFilterListParams() {
    this.l1InternalStatus =
      this.l1InternalStatuses != null
        ? this.l1InternalStatuses.join('~')!
        : null;

    this.taskOwner =
      this.taskOwners != null ? this.taskOwners.join('~')! : null;

    this.poeStatus =
      this.poeStatuses != null ? this.poeStatuses.join('~')! : null;

    this.incentiveStatus =
      this.incentiveStatuses != null ? this.incentiveStatuses.join('~')! : null;

    this.inputProfileStatus =
      this.inputProfileStatuses != null
        ? this.inputProfileStatuses.join('~')!
        : null;

    this.inputProgramType =
      this.inputProgramTypes != null ? this.inputProgramTypes.join('~')! : null;
  }
}
